import { Link, useAsyncValue } from "react-router-dom";
import styles from "./projects.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { themeContext } from "../context/theme";
import {
      faGamepad,
      faCartShopping,
      faVideo,
      faKeyboard,
      faUser,
      faArrowRight,
      faGreaterThan,
      faUpRightFromSquare,
      faLink,
} from "@fortawesome/free-solid-svg-icons";
import { useContext } from "react";
import { TimeSpent } from "./timeSpent";
import { ImageLoader } from "../components/loaders/imageLoader";

const icons = {
      faGamepad,
      faCartShopping,
      faVideo,
      faKeyboard,
      faUser,
      faArrowRight,
      faGreaterThan,
};

export const Projects = () => {
      const loaderData = useAsyncValue()[0];
      const { theme } = useContext(themeContext);
      console.log(loaderData);
      return (
            <div className={styles["projects"]}>
                  {loaderData.payload.map((project) => {
                        return (
                              <div
                                    className={
                                          styles["project"] +
                                          " " +
                                          styles["project-" + theme]
                                    }
                              >
                                    <ImageLoader
                                          preload={
                                                project.title === "Tetris (2.0)"
                                          }
                                          imageAttibutes={{
                                                src: project.images[0].replace(
                                                      "upload",
                                                      "upload/q_auto,f_auto"
                                                ),
                                                alt: "project",
                                                className:
                                                      styles[
                                                            "project-icon-container"
                                                      ],
                                          }}
                                          containerAttributes={{
                                                className:
                                                      styles["image-container"],
                                          }}
                                          loaderAttributes={{
                                                backgroundColor: "teal",
                                          }}
                                    ></ImageLoader>

                                    <div
                                          className={
                                                styles["project-information"]
                                          }
                                    >
                                          <div
                                                className={
                                                      styles["project-name"] +
                                                      " " +
                                                      styles[
                                                            "project-name-" +
                                                                  theme
                                                      ]
                                                }
                                          >
                                                {project.title}
                                          </div>
                                          <div className={styles["tech-stack"]}>
                                                {project.introduction
                                                      .split(" ")
                                                      .filter((word, index) => {
                                                            if (index < 15) {
                                                                  return word;
                                                            }
                                                            return false;
                                                      })
                                                      .join(" ")}
                                                ...
                                          </div>
                                          <TimeSpent
                                                project={project}
                                          ></TimeSpent>
                                    </div>
                                    <Link
                                          to={`/projects/${project._id}`}
                                          className={
                                                styles["project-link"] +
                                                " " +
                                                styles["project-link-" + theme]
                                          }
                                          aria-label="project link"
                                    >
                                          <FontAwesomeIcon icon={faLink} />
                                    </Link>
                              </div>
                        );
                  })}
            </div>
      );
};
